//默认导入
const { ccclass, property } = cc._decorator;
import ModuleBase, { bindButtonClickEvent, ViewLayer, moduleInit } from "../../../../framework/core/mvvm/module_base";
import WebFullScreenView from "./webfullscreen_view";
import Utility from "../../../../utility/utility";
import ModuleManager from "../../../../framework/core/module_manager";
import screenfull = require("screenfull");
import AppData from "../../const/app_data";
import TimeManager from "../../../../manager/time_manager";
import AppController from "../../../../sdk/app_controller";
@ccclass
@moduleInit("WebFullScreen")
export default class WebFullScreen extends ModuleBase<WebFullScreenView, null> {

    scheduleCallback: Function
    maxLanHet = 0;
    touchDown = false;
    scheduleId = null;
    canvasRatio = 0
    screenRatio = 0
    onScrollFull = false
    finger = null
    constructor() {
        super();
        this.package = "public";
        this.layer = ViewLayer.Highest;
        this.windowPrefabResPath = "package/public/web_fullscreen";
        this.viewType = WebFullScreenView;
        this.needViewMask = false
        this.clickAnywhereClose = false
    }
    onShow(intentData) {
        let self = this
        cc.view.getFrameSize()
        self.canvasRatio = Math.floor(AppData.designResolution.width / AppData.designResolution.height * 100) / 100
        self.screenRatio = Math.floor(window.screen.width / window.screen.height * 100) / 100
        if (self.screenRatio < 1) {
            self.screenRatio = Math.floor(window.screen.height / window.screen.width * 100) / 100
        }
        let firsScroll = false
        window.addEventListener('touchstart', function () {
            firsScroll = true
        }, false)
        window.addEventListener('touchend', function () {
        }, false)
        window.addEventListener('touchmove', function () {
            if (cc.sys.isBrowser && cc.sys.os == cc.sys.OS_IOS && Utility.isSafari()) {
                if (firsScroll) {
                    setTimeout(function () {
                        window.scrollTo(0, 1);
                    }, 100);
                    firsScroll = false
                }
            }
        }, false)
        window.addEventListener('touchcancel', function () {
        }, false)
        
        window.addEventListener("orientationchange", function () {
            if (cc.sys.isBrowser && cc.sys.os == cc.sys.OS_IOS) {
                self.iponeXFit()
                cc.log("orientationchange:", self.canvasRatio, self.onScrollFull, window.orientation)
                let isFull = self.isFullScreen()
                if (isFull) {
                    self.hideBtn()
                } else {
                    self.showBtn()
                }
            }
        }, false);
        cc.systemEvent.on("canvas_resize", function () {
            if (cc.sys.isBrowser) {
                self.canvasRatio = Math.floor(AppData.designResolution.width / AppData.designResolution.height * 100) / 100
                cc.log("canvas_resize:", self.canvasRatio, window.orientation)
                self.setBtnAlpha()
                self.setBtnBackground()
                if (cc.sys.os == cc.sys.OS_IOS) {
                    self.hideSwipe()
                    window.scrollTo(0, 0);
                    let isFull = self.isFullScreen()
                    if (self.onScrollFull || isFull) {
                        self.hideBtn()
                    } else {
                        self.showBtn()
                    }
                }
            }
        })

        self.view.btnfullscreen.on(cc.Node.EventType.TOUCH_START, (event) => {
            // self.touchDown = true;
        });
        self.view.btnfullscreen.on(cc.Node.EventType.TOUCH_MOVE, (event) => {
            self.touchDown = true;
            let delta = event.getDelta();
            self.view.btnfullscreen.x = self.view.btnfullscreen.x + delta.x;
            self.view.btnfullscreen.y = self.view.btnfullscreen.y + delta.y;
            self.setBtnAlpha()
        });
        let touchend = function () {
            self.touchDown = false;
            if (self.view.btnfullscreen.x > AppData.designResolution.width - 150) {
                self.view.btnfullscreen.x = AppData.designResolution.width - 55
            }
            if (self.view.btnfullscreen.y > AppData.designResolution.height - 130) {
                self.view.btnfullscreen.y = AppData.designResolution.height - 55
            }
            if (self.view.btnfullscreen.x < 150) {
                self.view.btnfullscreen.x = 55
            }
            if (self.view.btnfullscreen.y < 130) {
                self.view.btnfullscreen.y = 55
            }
            self.setBtnAlpha()
        }
        self.view.btnfullscreen.on(cc.Node.EventType.TOUCH_END, (event) => {
            touchend()
        });
        self.view.btnfullscreen.on(cc.Node.EventType.TOUCH_CANCEL, (event) => {
            touchend()
        });
        this.setBtnAlpha()
    }

    @bindButtonClickEvent("btnFull")
    btnFullScreen() {
        if (this.touchDown) {
            return
        }
        if (cc.sys.isBrowser) {
            if (cc.sys.os == cc.sys.OS_IOS) {
                if (Utility.isSafari() || Utility.openInFacebook() || Utility.openInLine() || Utility.isIosChrome()) { //|| Utility.isChrome()
                    this.displaySwipe()
                }
                else {
                    ModuleManager.instance.toastKey("safari_tips");
                    if (AppData.userConnectEnvi == 2) {  //test
                        this.displaySwipe()
                    }
                }
            } else {
                if (screenfull.isFullscreen) {
                    screenfull.exit()
                    this.view.backgroundin.active = true
                    this.view.backgroundout.active = false
                } else {
                    if (screenfull.isEnabled) {
                        screenfull.request();
                        this.view.backgroundin.active = false
                        this.view.backgroundout.active = true
                    }
                }
            }
        }
    }

    setBtnAlpha() {
        let self = this
        self.view.btnfullscreen.opacity = 255
        if (this.scheduleId != null) {
            TimeManager.instance.cancelSchedule(this.scheduleId)
            this.scheduleId = null
        }
        this.scheduleId = TimeManager.instance.doScheduleOnce(function () {
            self.view.btnfullscreen.opacity = 80
            self.setBtnBackground()
        }, 3)
    }
    hideBtn() {
        this.view.btnfullscreen.active = false
    }
    showBtn() {
        this.view.btnfullscreen.active = true
    }
    setBtnBackground() {
        if (cc.sys.os == cc.sys.OS_IOS) {
            this.view.backgroundin.active = true
            this.view.backgroundout.active = false
        } else {
            this.view.backgroundin.active = !screenfull.isFullscreen
            this.view.backgroundout.active = screenfull.isFullscreen
        }
    }

    isFullScreen() {
        let full = false
        cc.log("isFullScreen:", window.innerHeight, document.documentElement.clientHeight, this.screenRatio, this.canvasRatio)
        if (Utility.isLandscape()) {
            if (Utility.openInFacebook() || Utility.isIosChrome()) {
                if (this.screenRatio > 2) {
                    full = this.canvasRatio < 2.1   //1.95 2.18 1.76      2.32 1.88
                } else {
                    full = this.canvasRatio < 2
                }
            } else {
                full = this.canvasRatio == this.screenRatio
            }
        } else {
            if (this.screenRatio > 2) {
                full = this.canvasRatio > 1.95 //(line == 2)
            } else {
                full = this.canvasRatio > 1.6  //1.66  1.6
            }
        }
        cc.log("data:", Utility.isLandscape(), Utility.openInFacebook(), full)
        return full
    }



    displaySwipe() {
        if (window.innerHeight == document.documentElement.clientHeight && Utility.isSafari() && Utility.isLandscape()) {
            return
        }
        let mask = document.getElementById("mask");
        let bodyTag = document.getElementsByTagName('body')[0];
        if (Utility.isLandscape()) {
            this.finger = document.getElementById("upswipe")
        } else {
            this.finger = document.getElementById("leftswipe")
        }
        this.finger.style.display = "block"
        mask.style.display = "block";
        bodyTag.style.height = '150%';
        if (Utility.openInLine()) {
            bodyTag.style.height = '100%';
        }
        if (!(Utility.isSafari() && Utility.isLandscape())) {
            document.body.style.overflow = "visible"
        }
        this.onScrollFull = true
        if(Utility.isIosChrome()){
            cc.view.setAvaliSize(true)
        }
    }
    hideSwipe() {
        let mask = document.getElementById("mask");
        let bodyTag = document.getElementsByTagName('body')[0];
        bodyTag.style.height = '100%';
        mask.style.display = "none";
        if(this.finger != null ){
            this.finger.style.display = "none"
        }
        document.body.style.overflow = "hidden"
        this.onScrollFull = false
        if(Utility.isIosChrome()){
            setTimeout(function () {
                cc.view.setAvaliSize(false)
            }, 100);
        }
    }


    iponeXFit() {
        if (cc.sys.os == cc.sys.OS_IOS && screen.height / screen.width >= 2) {
            if (Utility.isSafari() && !navigator.standalone) {
                if (Utility.isLandscape()) {
                    if (screen.height % 896 == 0) //如果横屏之后的宽度除以896 能除尽， 那么就需要设置width 896 +1 主要是 一款XR 和 XS Max
                    {
                        document.querySelector('meta[name=viewport]').content = 'width=897,user-scalable=no,initial-scale=1, minimum-scale=1,maximum-scale=1,viewport-fit=cover'
                    }
                    else if (screen.height % 812 == 0)//如果横屏之后的宽度除以812 能除尽， 那么就需要设置width 812 +1 主要是 x 和 XS 以及 一款 XR？
                    {
                        document.querySelector('meta[name=viewport]').content = 'width=813,user-scalable=no,initial-scale=1, minimum-scale=1,maximum-scale=1,viewport-fit=cover'
                    } else if (screen.height % 736 == 0)// 7 plus 8 plus
                    {
                        document.querySelector('meta[name=viewport]').content = 'width=737,user-scalable=no,initial-scale=1, minimum-scale=1,maximum-scale=1,viewport-fit=cover'
                    }
                    else if (screen.height % 667 == 0)// 7 和 8 6s
                    {
                        document.querySelector('meta[name=viewport]').content = 'width=668,user-scalable=no,initial-scale=1, minimum-scale=1,maximum-scale=1,viewport-fit=cover'
                    }
                    else //低于6s
                    {
                        document.querySelector('meta[name=viewport]').content = 'width=device-width,user-scalable=no,initial-scale=1, minimum-scale=1,maximum-scale=1,viewport-fit=cover'
                    }
                } else {
                    document.querySelector('meta[name=viewport]').content = 'width=device-width,user-scalable=no,initial-scale=1, minimum-scale=1,maximum-scale=1,viewport-fit=cover'
                }
            }
        }
    }

}